import Image from 'next/image';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from './design-illustrations.module.css';
import t1 from '../../public/design/team/1-min.png';
import t2 from '../../public/design/team/2-min.png';
import t3 from '../../public/design/team/3-min.png';
import t4 from '../../public/design/team/4-min.png';
import t5 from '../../public/design/team/5-min.png';
import t6 from '../../public/design/team/6-min.png';
import t7 from '../../public/design/team/7-min.png';
import t8 from '../../public/design/team/8-min.png';
import t9 from '../../public/design/team/9-min.png';
import { Container } from '../../components';

export default function DesignIllustrations() {
  const isMob = useMediaQuery({
    query: '(max-width: 768px)',
  });
  return (
    <section className={styles.root}>
      <Container>
        <h2 className={styles.title} id="illustrations">
          Illustrations
        </h2>
        <div className={styles.row}>
          <p className={styles.text}>
            The icing on the cake of any type of the visual may be an
            illustration. We can easily show familiar things by adding a unique
            style designed special for you. Our illustrations stand out with
            emotions and moods, so it&apos;s hard to look away!
          </p>
          <div className={styles.box}>
            <span className={styles.counter}>05</span>
            <span className={styles.subtitle}>Sketching</span>
          </div>
        </div>
      </Container>
      <div className={styles.illustration}>
        <Container>
          <div className={styles.block}>
            <div className={styles.avatar}>
              <Image
                alt="Photo profile Ruslan Yalanskyy"
                width={379}
                height={410}
                src={t1}
              />
            </div>
            <div
              className={styles.avatar}
              style={{ marginTop: isMob ? '15px' : '52px' }}
            >
              <Image
                alt="Photo profile Viсtoria Sheinina"
                width={396}
                height={410}
                src={t2}
              />
            </div>
            <div className={styles.avatar}>
              <Image
                alt="Photo profile Denys Kozedub"
                width={383}
                height={410}
                src={t3}
              />
            </div>
          </div>
          <div className={styles.block}>
            <div className={styles.avatar}>
              <Image
                alt="Photo profile Dmytro D"
                width={378}
                height={410}
                src={t4}
              />
            </div>
            <div className={styles.avatar}>
              <Image
                alt="Photo profile Anna Ivanova"
                width={396}
                height={410}
                src={t5}
              />
            </div>
            <div className={styles.avatar}>
              <Image
                alt="Photo profile Glib Goncharov"
                width={383}
                height={410}
                src={t6}
              />
            </div>
          </div>
          <div className={styles.block}>
            <div className={styles.avatar}>
              <Image
                alt="Photo profile Alexey Koloskov"
                width={379}
                height={410}
                src={t7}
              />
            </div>
            <div
              className={styles.avatar}
              style={{
                marginTop: isMob ? '-15px' : '-31px',
              }}
            >
              <Image
                alt="Photo profile Lukin Oleksandr"
                width={449}
                height={439}
                src={t8}
              />
            </div>
            <div className={styles.avatar}>
              <Image
                alt="Photo profile Nikita Sergienko"
                width={383}
                height={410}
                src={t9}
              />
            </div>
          </div>
          <div className={styles.turkey}>
            <Image alt="Turkey picture" src="/design/team/turkey-min.png" width={592} height={595} />
          </div>
        </Container>
      </div>
    </section>
  );
}
